<template>
  <div class="empty-state">
    <div class="empty-state-content">
      <!-- 图标 -->
      <div class="empty-icon">
        <svg v-if="icon === 'news'" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6H20V18H4V6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4 6L12 13L20 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else-if="icon === 'search'" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
          <path d="21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else-if="icon === 'error'" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
          <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
          <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
        </svg>
        <svg v-else-if="icon === 'warning'" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="12" cy="17" r="1" fill="currentColor"/>
        </svg>
        <svg v-else width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
          <circle cx="9" cy="9" r="2" stroke="currentColor" stroke-width="2"/>
          <path d="21 15L16 10L5 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      
      <!-- 标题 -->
      <h3 class="empty-title">{{ title || 'No Content' }}</h3>
      
      <!-- 描述 -->
      <p class="empty-description">{{ description || 'There is currently no content to display' }}</p>
      
      <!-- 操作按钮 -->
      <div v-if="showAction" class="empty-actions">
        <button 
          class="btn btn-primary empty-action-btn" 
          @click="handleAction"
        >
          {{ actionText || 'Refresh' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    // 图标类型
    icon: {
      type: String,
      default: 'default',
      validator: value => ['default', 'news', 'search', 'error', 'warning'].includes(value)
    },
    // 标题
    title: {
      type: String,
      default: 'No Content'
    },
    // 描述
    description: {
      type: String,
      default: 'There is currently no content to display'
    },
    // 是否显示操作按钮
    showAction: {
      type: Boolean,
      default: false
    },
    // 操作按钮文本
    actionText: {
      type: String,
      default: 'Refresh'
    }
  },
  methods: {
    handleAction() {
      this.$emit('action');
    }
  }
}
</script>

<style scoped>
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 40px 20px;
}

.empty-state-content {
  text-align: center;
  max-width: 400px;
}

.empty-icon {
  margin-bottom: 24px;
  color: #d1d5db;
  display: flex;
  justify-content: center;
}

.empty-icon svg {
  width: 64px;
  height: 64px;
}

.empty-title {
  font-size: 20px;
  font-weight: 600;
  color: #f5f5f6;
  margin-bottom: 20px;
  margin-top: 0;
}

.empty-description {
  font-size: 16px;
  color: #8e939c;
  line-height: 1.5;
  margin-bottom: 20px;
  margin-top: 0;
}

.empty-actions {
  margin-top: 24px;
}

.empty-action-btn {
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  background-color: #3b82f6;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.empty-action-btn:hover {
  background-color: #2563eb;
}

.empty-action-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .empty-state {
    min-height: 250px;
    padding: 30px 15px;
  }
  
  .empty-icon svg {
    width: 48px;
    height: 48px;
  }
  
  .empty-title {
    font-size: 18px;
  }
  
  .empty-description {
    font-size: 14px;
  }
}
</style>